import React from "react";
import { LayoutDashboard, Users, Gift, Settings, Download, LogOut, ScrollText, Heart, Tag } from "lucide-react";

export const NAV = [
  ["overview", "Overview", LayoutDashboard],
  ["registrations", "Registrations", Users],
  ["gifts", "Jersey Gifts", Gift],
  ["sponsorships", "Sponsorships", Heart],
  ["referrals", "Referrals", Tag],
  ["config", "Configuration", Settings],
  ["exports", "Exports", Download],
  ["audit", "Audit Log", ScrollText],
];

export function AdminSidebar({ tab, setTab, onLogout }) {
  return (
    <aside className="hidden md:flex w-60 bg-[#03281B] text-white flex-col shrink-0 min-h-screen sticky top-0">
      <div className="p-5 border-b border-white/10">
        <div className="font-display font-extrabold text-lg">SPORTING CP CAMP</div>
        <div className="text-[10px] uppercase tracking-widest text-[#F3C242]">Admin Dashboard</div>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {NAV.map(([key, label, Icon]) => (
          <button key={key} data-testid={`admin-nav-${key}`} onClick={() => setTab(key)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors ${tab === key ? "bg-[#008057] text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`}>
            <Icon size={18} /> {label}
          </button>
        ))}
      </nav>
      <button onClick={onLogout} data-testid="admin-logout" className="m-3 flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-semibold text-white/60 hover:text-white hover:bg-white/5"><LogOut size={18} /> Sign Out</button>
    </aside>
  );
}

export function AdminMobileNav({ tab, setTab, onLogout }) {
  return (
    <div className="md:hidden sticky top-0 z-30 bg-[#03281B] text-white">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="font-display font-extrabold">SPORTING CP CAMP <span className="text-[#F3C242] text-xs align-middle">Admin</span></div>
        <button onClick={onLogout} data-testid="admin-mobile-logout" className="text-white/70"><LogOut size={18} /></button>
      </div>
      <div className="flex gap-2 overflow-x-auto px-4 pb-3 no-scrollbar">
        {NAV.map(([key, label, Icon]) => (
          <button key={key} data-testid={`admin-mnav-${key}`} onClick={() => setTab(key)} className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold ${tab === key ? "bg-[#008057] text-white" : "bg-white/10 text-white/70"}`}>
            <Icon size={14} /> {label}
          </button>
        ))}
      </div>
    </div>
  );
}
